<template>
  <template v-if="field_type === 'boolean'">
    <!--CUSTOM FIX FOR PLATFORMS-->
    <template v-if="page_name === 'platformmanagement'">
      <!--CUSTOM FIX FOR SMOKING ICONS-->
      <PhCigaretteSlash v-if="field_name === 'not_smoking' && item[field_name]" color="red" size="24"/>
      <PhCigarette v-else-if="field_name === 'not_smoking'" color="green" size="24"/>
      <v-icon v-else-if="item[field_name]" color="success" size="large" icon="mdi-check-all"/>
      <v-icon v-else color="error" size="large" icon="mdi-close"/>
    </template>
    <!--CUSTOM FIX FOR PUNCHLIST ITEMS-->
    <template v-else-if="page_name === 'punchlistitems'">
      <!--CUSTOM FIX TO REVERT OPEN/CLOSED STATUS-->
      <template v-if="field_name === 'status' && item[field_name]">Closed</template>
      <template v-else-if="field_name === 'status'">Open</template>
      <template v-else-if="field_name === 'technical_authority_required' && item[field_name]">Yes</template>
      <template v-else-if="field_name === 'technical_authority_required'">No</template>
      <template v-else-if="field_name === 'active' && item[field_name]">Accepted</template>
      <template v-else-if="field_name === 'active'">Draft</template>
      <template v-else-if="field_name === 'rejected' && item[field_name]">Yes</template>
      <template v-else-if="field_name === 'rejected'">No</template>
      <v-icon v-else-if="item[field_name]" color="success" size="large" icon="mdi-check-all"/>
      <v-icon v-else color="error" size="large" icon="mdi-close"/>
    </template>
    <!--OTHER MODELS-->
    <template v-else>
      <v-icon v-if="item[field_name]" color="success" size="large" icon="mdi-check-all"/>
      <v-icon v-else color="error" size="large" icon="mdi-close"/>
    </template>
  </template>
  <!--DATES-->
  <template v-else-if="field_type === 'date' && item[field_name] && (field_name === 'created_at' || field_name === 'updated_at')">
    {{ moment(item[field_name], "YYYY-MM-DD").format("DD-MM-YYYY") }}
  </template>
  <!--DROPDOWNS-->
  <template v-else-if="field_type === 'select_single' && item[field_name]">
    <template v-if="Array.isArray(item[field_name])">
      <span v-if="item[field_name].length > 0">{{ $lodash.truncate($store.getters.translate(item[field_name][0]), { length: 40 }) }}</span>
    </template>
    <template v-else>
      {{ $lodash.truncate($store.getters.translate(item[field_name]), { length: 40 }) }}
    </template>
  </template>
  <template v-else-if="field_type === 'select_multiple' && item[field_name]">
    <div class="d-flex align-center flex-wrap" style="gap: 5px;">
      <template v-if="Array.isArray(item[field_name])">
        <v-chip v-if="item[field_name].length > 0" rounded="0" size="small" class="ma-0" color="primary" style="height: 24px;">
          {{ $lodash.truncate($store.getters.translate(item[field_name][0]), { length: 40 }) }}
        </v-chip>
        <v-menu v-if="item[field_name].length > 1" :close-on-content-click="false">
          <template #activator="{ props }">
            <v-chip v-bind="props" rounded="0" size="small" class="ma-0" color="primary" style="height: 24px;">
              +{{ item[field_name].length - 1 }}
            </v-chip>
          </template>
          <v-list density="compact">
            <v-list-item v-for="elem in item[field_name].slice(1)">
              <v-list-item-title>
                {{ $lodash.truncate($store.getters.translate(elem), { length: 40 }) }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-else>
        <v-chip rounded="0" size="small" class="ma-0" color="primary" style="height: 24px;">
          {{ $lodash.truncate($store.getters.translate(item[field_name]), { length: 40 }) }}
        </v-chip>
      </template>
    </div>
  </template>
  <!--LINKS-->
  <template v-else-if="field_type === 'link'">
    <a class="sm-bold">
      <v-avatar v-if="field_name === 'name' && (item.avatar || (item.person && item.person.avatar))" class="mr-1" size="20">
        <v-img v-if="item.avatar" style="border: 1px" :src="item.avatar"/>
        <v-img v-else-if="item.person && item.person.avatar" style="border: 1px" :src="item.person.avatar"/>
        <v-img v-else style="border: 1px" src="../../../assets/images/no-user.jpg"/>
      </v-avatar>
      <!--CUSTOM FIX FOR TRANSLATION KEYS BECAUSE WE SHOULD SHOW THEM "AS IS"-->
      <template v-if="page_name === 'translations' && field_name === 'key'">
        {{ $lodash.truncate(item[field_name], { length: 40 }) }}
      </template>
      <template v-else>
<!--        {{ $lodash.truncate($store.getters.translate(item[field_name]), { length: 40 }) }}-->
        {{ $store.getters.translate(item[field_name]) }}
      </template>
    </a>
  </template>
  <!--TEXT FIELDS-->
  <template v-else-if="field_type === 'text_area'">
    <v-menu v-if="item[field_name]" :offset="[10, 0]" location="right bottom" :close-on-content-click="false">
      <template #activator="{ props }">
        <v-btn v-bind="props" icon size="small" variant="text" color="primary">
          <PhChatTeardropText size="24" />
        </v-btn>
      </template>
      <v-card max-width="400" min-width="300" elevation="1" color="greens-100" border="sm" class="sm-normal">
        <v-card-text class="pa-2" style="max-height: 200px; overflow-y: auto;">
          <div style="white-space: pre-wrap; word-break: break-word;">
            {{ $lodash.truncate($store.getters.translate(item[field_name]), { length: 600 }) }}
          </div>
        </v-card-text>
      </v-card>
    </v-menu>
  </template>
  <template v-else>
<!--    {{ $lodash.truncate($store.getters.translate(item[field_name]), { length: 40 }) }}-->
    {{ $store.getters.translate(item[field_name]) }}
  </template>
</template>

<script>
import {PhChatTeardropText, PhCigarette, PhCigaretteSlash} from "@phosphor-icons/vue";

export default {
  components: {PhCigarette, PhCigaretteSlash, PhChatTeardropText},
  props: ["item", "field_name", "field_type", "page_name"],
};
</script>